import React from 'react';
import Timer from 'react-compound-timer';
import styled from '@emotion/styled';

const START_TIME = 0;
const MILLISECOND_DELAY = 177;

let showNegativeSeconds = true;

const getFormattedSeconds = second => {
  const formattedSecond = showNegativeSeconds
    ? second < 21
      ? `${-(20 - second)}`
      : second - 20
    : second;
  return formattedSecond.toString();
};

const hideNegativeSeconds = minute => {
  if (minute > 0) {
    showNegativeSeconds = false;
  }
  return minute.toString();
};

const controlTimer = (state, start, stop) => {
  if (state === 'START') {
    start();
    return;
  }

  if (state === 'STOP') {
    stop();
    return;
  }
};

const StyledH1 = styled.h1`
  text-align: left;
`;

const CountdownTimer = props => {
  const { timerState } = props;
  return (
    <Timer initialTime={START_TIME} timeToUpdate={MILLISECOND_DELAY} startImmediately={false}>
      {({ start, stop }) => {
        controlTimer(timerState, start, stop);

        return (
          <StyledH1>
            <Timer.Hours />:<Timer.Minutes formatValue={value => hideNegativeSeconds(value)} />:
            <Timer.Seconds formatValue={value => getFormattedSeconds(value)} />:
            <small>
              <Timer.Milliseconds formatValue={value => value.toString().padStart(3, '0')} />
            </small>
          </StyledH1>
        );
      }}
    </Timer>
  );
};

export default CountdownTimer;
